import FormsPage from "@/pages/forms";
import type { RouteConfig } from "../models/types";

export const formRoutes: RouteConfig[] = [
	{
		path: "/forms",
		element: <FormsPage />,
	},
	{
		path: "/forms/:AssetIdParam",
		element: <FormsPage />,
	},
];
